<template>
	<el-drawer size="600px" title="绑定京东小程序" :visible.sync="dialogVisible" :modal-append-to-body="false" :wrapperClosable="false"
		class="customer-drawer-common bind-jd">
		<el-steps :active="active" simple>
		  <el-step title="绑定京东小程序" icon="el-icon-edit"></el-step>
		  <el-step title="完成绑定" icon="el-icon-upload"></el-step>
		</el-steps>
		<section style="margin-top: 20px;" v-if="active == 1">
			<el-form ref="form" :model="form" :rules="formRules" label-width="120px">
				<el-form-item label="京东名称：" prop="app_name">
					<el-input placeholder="请输入京东名称" v-model="form.app_name" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="京东APPID：" prop="app_id">
					<el-input placeholder="请输入APPID" v-model="form.app_id" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="AppSecret：" prop="app_secret">
					<el-input placeholder="请输入AppSecret" v-model="form.app_secret" clearable>
					</el-input>
				</el-form-item>
			</el-form>
		</section>
		<section style="margin-top: 20px;" v-else>
			<div class="step-finish">
				<span class="lable">URL</span>
				<el-input v-model="form.message_url" disabled style="width: 400px;"></el-input>
				<el-button type="text" @click="onCopy(form.message_url)">复制</el-button>
			</div>
			<p class="tips">将系统生成的URL写到京东后台的客服管理的消息地址里；</p>
		</section>
		<div class="footer">
			<el-button @click="dialogVisible = false" size="mini">{{active == 1 ? '取 消' : '关 闭'}}</el-button>
			<el-button v-show="active == 1" type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
			</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import {copyTextToClipboard} from '@/utils/functions.js'
	export default {
		data(){
			return {
				active:1,
				loading:false,
				dialogVisible:false,
				form:{
					app_name:'',
					app_id:'',
					app_secret:'',
					message_url:''
				},
				formRules:{
					app_name:[{ required: true, message: '请输入京东名称', trigger: 'blur' }],
					app_id:[{ required: true, message: '请输入京东APPID', trigger: 'blur' }],
					app_secret:[{ required: true, message: '请输入AppSecret', trigger: 'blur' }],
				}
			}
		},
		methods:{
			onSave(){
				this.$refs.form.validate((valid) => {
					if(valid){
						let params = JSON.parse(JSON.stringify(this.form));
						delete params.message_url;
						this.$api.apiAddBindJdItem(params).then(res => {
							if(res.errcode != 0) return;
							this.$notify.success('操作成功');
							this.form.message_url = res.data;
							this.active = 2;
							this.$emit('getList')
						})
					}
				})
			},
			openBind(row){
				this.dialogVisible = true;
				this.active = row ? 2 : 1;
				Object.keys(this.form).map(item => {
					this.form[item] = '';
				})
				this.form.message_url = row?.msgUrl || '';
			},
			onCopy(value){
				copyTextToClipboard(value,()=>{
					this.$message.success("复制成功")
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bind-jd {
		.tips {
			font-size: 12px;
			color: #F29522;
			padding-left: 120px;
			margin-top: 15px;
		}
		.step-finish {
			display: flex;
			.lable {
				display: inline-block;
				width: 120px;
				color: #838A9D;
				font-size: 12px;
				text-align: right;
				line-height: 36px;
				padding-right: 12px;
			}
			::v-deep {
				.el-button {
					margin-left: 5px;
				}
			}
		}
	}
</style>
